<template>
  <div class="Rename">
    <el-dialog
      class="customDialog renameDialog"
      title="修改数据表名称"
      :visible.sync="isShow"
      width="460px"
      @close="closeDialog"
      top="15vh"
      :close-on-click-modal = 'false'
      :close-on-press-escape = 'false'
      :show-close="false"
    >
      <el-input v-model.trim="name" placeholder="表名称（不能为空）" :class="!showError?'':'isError'" @input="changeName"></el-input>
      <span style="color: #d50000;transform: translateY(5px);display: block;text-align: left;position: absolute" v-if="showError">{{errorMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="true" v-if="loading"></el-button>
        <el-button type="primary" @click="submit" v-else>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { editApiForm } from '@/api/dataManagement'
export default {
  name: 'Rename',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  components: { },
  data () {
    return {
      showDialog: false,
      name: '',
      id: '',
      loading: false,
      errorMsg: '',
      showError: false
    }
  },
  computed: {
    isShow: {
      get: function (v) {
        if (v && this.data) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.name = this.data.name
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.id = this.data.id
        }
        return this.show
      },
      set: function (v) {
        // 点击关闭按钮更新父组件传过来的参数为false
        this.$emit('update:show', v)
      }
    }
  },
  methods: {
    changeName (v) {
      if (!v.trim()) {
        this.showError = true
        this.errorMsg = '名字不能为空！'
      } else if (v.trim().length > 20) {
        this.showError = true
        this.errorMsg = '表名称过长，请输入20个字以内！'
      } else {
        this.showError = false
        this.errorMsg = ''
      }
    },
    submit () {
      if (this.showError) return
      this.loading = true
      let params = {}
      if (this.data.dataSourceType === 'EXCEL') {
        params = { id: this.data.id, name: this.name }
      }
      if (this.data.dataSourceType === 'API') {
        params = {
          httpApiConfig: {
            alias: JSON.parse(this.data.params).alias,
            id: JSON.parse(this.data.params).id
          },
          id: this.data.id,
          name: this.name
        }
      }
      editApiForm(params).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg || '操作成功！')
          this.$emit('refreshTable', { id: this.id, name: this.name })
          this.isShow = false
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel () {
      this.isShow = false
    },
    closeDialog () {
      this.loading = false
      this.showError = false
      this.errorMsg = ''
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .Rename{
    .renameDialog{
      .el-dialog{
        box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
        .el-dialog__header{
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          padding: 10px !important;
          border: 0;
          padding-left: 20px !important;
        }
        .el-dialog__body{
          padding-left: 20px;
          padding-right: 20px;
          .isError{
            .el-input__inner{
              border-color: red;
            }
          }
        }
      }
    }
  }
</style>
